import InteractionControlBlock from "@/app/routing/shared-blocks/InteractionControlBlock";
import { BaseView } from "@/app/routing/views/_base-view/BaseView";
import { createLogger } from "@/sdk";
import { STORE } from "@/store";
import { MediaType } from "@/store/store-agent-contact";
import { Router } from "@uuip/unified-ui-platform";
import { css } from "lit-element";
import RouteNotFoundBlock from "../_not-found-view/blocks/RouteNotFoundBlock";
import PanelOneBlock from "./blocks/PanelOneBlock";
import PanelTwoBlock from "./blocks/PanelTwoBlock";
import style from "./TaskSelectedView.scss";
const logger = createLogger("AgentXBaseView");
const taskArrayHasLength = () => {
    STORE.agentContact.taskArray.length
        ? logger.info(`agentContact taskArray has length ${STORE.agentContact.taskArray.length}`)
        : logger.info(`agentContact taskArray has no length ${STORE.agentContact.taskArray.length}`);
    return STORE.agentContact.taskArray.length;
};
function queuedTasksStyles() {
    return css `
    :host {
      grid-template-areas:
        "header header header header header"
        "nav banner banner banner ai"
        "nav tasks common-control panel-two ai"
        "nav tasks panel-one panel-two ai";
      grid-template-columns: var(--nav-bar-width) auto minmax(auto, 2fr) 1.5fr auto;
      grid-template-rows: auto auto auto 1fr auto;
    }
  `;
}
function openTasksStyles() {
    var _a, _b;
    if (STORE.agentContact.taskSelected) {
        if (((_a = STORE.agentContact.taskSelected) === null || _a === void 0 ? void 0 : _a.mediaType) === MediaType.Telephony ||
            ((_b = STORE.agentContact.taskSelected) === null || _b === void 0 ? void 0 : _b.mediaType) === MediaType.Midcall) {
            return css `
        :host {
          grid-template-areas:
            "header header header header header"
            "nav banner banner banner ai"
            "nav tasks common-control common-control ai"
            "nav tasks panel-two panel-two ai";
          grid-template-columns: var(--nav-bar-width) auto 1fr 1fr auto;
          grid-template-rows: auto auto auto 1fr auto;
        }
      `;
        }
        else {
            return css `
        :host {
          grid-template-areas:
            "header header header header header"
            "nav banner banner banner ai"
            "nav tasks common-control panel-two ai"
            "nav tasks panel-one panel-two ai";
          grid-template-columns: var(--nav-bar-width) auto minmax(auto, 2fr) 1.5fr auto;
          grid-template-rows: auto auto auto 1fr auto;
        }
      `;
        }
    }
    else {
        return css `
      :host {
        grid-template-areas:
          "header header header header header"
          "nav banner banner banner ai"
          "nav tasks common-control common-control ai"
          "nav tasks route_not_found route_not_found ai";
        grid-template-columns: var(--nav-bar-width) auto 1fr 1fr auto;
        grid-template-rows: auto auto auto 1fr auto;
      }
    `;
    }
}
function mapQueuedTaskToContactProperties(task) {
    const interaction = {
        interactionId: task.id,
        mediaResourceId: "",
        customerName: task.customerName,
        customerNumber: task.customerPhone,
        contactPhoneNumber: task.customerPhone,
        ani: task.ani,
        displayAni: task.displayAni,
        dnis: task.dnis || task.customerEmail,
        sourceNumber: task.origin,
        // Media type information
        mediaType: task.mediaType,
        mediaChannel: task.mediaChannel,
        // State information
        isWrapUp: false,
        state: task.state,
        isQueued: true,
        // Direction & ownership
        contactDirection: task.taskDirection,
        isConsultInProgress: task.isConsult,
        isConferenceInProgress: task.isConferencing,
        owner: task.ownerName,
        ownerName: task.ownerName,
        isOwner: false,
        // Organization info
        orgId: STORE.agent.orgId,
        virtualTeamName: task.virtualTeamName || task.queueName,
        // Timestamps
        timeStamp: task.createdTime,
        // Queue information
        queueId: task.queueId,
        contactQueue: task.queueName,
        // Call state information
        isHold: task.isHold,
        primaryMediaParticipants: {},
        ctqInProgress: false,
        // Entry point information
        pathId: task.entrypointId,
        ivrPath: task.entrypointId,
        // Subject/Details
        additionalDetails: task.contactReason,
        // Call type
        outboundType: task.outboundType,
        appUser: task.appUser
    };
    return {
        isTelephoneOrMidcall: task.mediaType === MediaType.Telephony || task.mediaType === MediaType.Midcall,
        isNotTelephoneOrMidcall: task.mediaType !== MediaType.Telephony && task.mediaType !== MediaType.Midcall,
        taskSelected: interaction,
        isDefinedIvrTranscript: false,
        isCallMuted: false,
        getInteractionId: () => task.id,
        getAgentCallMonitoringStateDetails: {},
        getWebexCallingCallId: undefined,
        getCADSectionOpenStatus: false,
        getMainCadSectionStatus: false,
        getConsultCadSectionStatus: false,
        callPersistence: false,
        // Functions that are no-ops for queued tasks
        updateCadSectionDimension: (_key, _value) => {
            //no-op
        },
        resetInteractionControlDimensions: () => {
            //no-op
        },
        updateWarnOnNavigation: (_detail) => {
            //no-op
        },
        resetWarningOnNavigation: () => {
            //no-op
        },
        setMonitoringOwnerName: (_detail) => {
            //no-op
        },
        setIsMonitoringNotEndedManually: (_isEnded) => {
            //no-op
        },
        // Optional property for call guide
        getCallGuideProps: {
            outboundType: task.outboundType || "",
            owner: ""
        }
    };
}
function TaskNotFoundView(homeHref) {
    return new Router.RouterView.BlocksMap(BaseView(), {
        blocks: { route_not_found: RouteNotFoundBlock(homeHref, "task-not-found") },
        styles: [style, openTasksStyles()]
    });
}
function OpenTaskSelectedView() {
    return new Router.RouterView.BlocksMap(BaseView(), {
        blocks: Object.assign({ panel_one: PanelOneBlock() }, (taskArrayHasLength() && { aux_pane: PanelTwoBlock() })),
        styles: [style, openTasksStyles()]
    });
}
function QueuedTaskSelectedView(contactProperties) {
    return new Router.RouterView.BlocksMap(BaseView(), {
        blocks: {
            common_control: InteractionControlBlock(contactProperties),
            queued_panel_one: PanelOneBlock(contactProperties, true),
            queued_aux_pane: PanelTwoBlock(contactProperties)
        },
        styles: [style, queuedTasksStyles()]
    });
}
export const TaskSelectedView = (homeHref) => {
    var _a;
    const navigatedTaskId = STORE.routing.currentRouteValues.params.taskId;
    if (STORE.agentContact.interactionIds.indexOf(navigatedTaskId) !== -1) {
        return OpenTaskSelectedView();
    }
    else if (((_a = STORE.tasks.selectedTask) === null || _a === void 0 ? void 0 : _a.id) === navigatedTaskId) {
        const task = STORE.tasks.getTaskById(navigatedTaskId);
        if (task) {
            return QueuedTaskSelectedView(mapQueuedTaskToContactProperties(task));
        }
    }
    return TaskNotFoundView(homeHref);
};
